<div class="ui-g pie-container">
  <div class="ui-g-12">{{headerStr}}</div>
  <div class="ui-g-12">
    <p-chart type="pie" [data]="buildData"></p-chart>
  </div>
</div>